const rankingItems = [
  { rank: 1, title: '星际穿越', type: '科幻', hot: '9.4分', trend: 'up' },
  { rank: 2, title: '肖申克的救赎', type: '剧情', hot: '9.7分', trend: 'stable' },
  { rank: 3, title: '黑暗荣耀', type: '韩剧', hot: '9.0分', trend: 'up' },
  { rank: 4, title: '漫长的季节', type: '国产剧', hot: '9.4分', trend: 'up' },
  { rank: 5, title: '盗梦空间', type: '科幻', hot: '9.3分', trend: 'stable' },
  { rank: 6, title: '鱿鱼游戏第二季', type: '韩剧', hot: '8.5分', trend: 'new' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">热播榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">全网观众热追排行，实时更新</p>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold whitespace-nowrap ${
                item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.type}</span>
              </div>
              <span className="text-xs text-accent-700 font-medium whitespace-nowrap">{item.hot}</span>
              <span className="w-5 h-5 flex items-center justify-center">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                {item.trend === 'new' && <i className="ri-sparkling-line text-accent-500 text-sm"></i>}
                {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}